import script from "./EpochProgress.vue?vue&type=script&setup=true&lang=ts"
export * from "./EpochProgress.vue?vue&type=script&setup=true&lang=ts"

import "./EpochProgress.vue?vue&type=style&index=0&id=2e9111fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e9111fa"]])

export default __exports__